var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirculo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 191,
    viewBox: "0 0 191 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95.2609,
    cy: 95.2608,
    r: 94.5,
    transform: "rotate(-0.463194 95.2609 95.2608)",
    fill: "#285171",
    fillOpacity: 0.19
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.7484,
    cy: 93.7324,
    r: 65,
    transform: "rotate(-0.463194 98.7484 93.7324)",
    fill: "#285171",
    fillOpacity: 0.46
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.1015 79.6291L91.0891 78.0991C91.0617 74.7141 91.0395 71.9793 97.3166 71.9284L100.453 71.903C106.73 71.8521 106.752 74.5869 106.78 77.9719L106.792 79.5019M91.3497 110.228L107.04 110.101C114.924 110.037 116.312 106.944 116.694 103.195L118.04 87.8833C118.533 83.2126 117.128 79.418 108.753 79.4859L89.1402 79.645C80.7659 79.7129 79.424 83.5298 79.991 88.1918L81.5855 103.479C82.0281 107.222 83.4662 110.292 91.3497 110.228Z",
    stroke: "#285171",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4135 93.906C89.4297 93.3972 84.6316 91.7406 80.3955 89.0662M103.81 93.8298C108.785 93.2403 113.555 91.5061 117.748 88.7633M103.316 94.193C103.325 95.3201 102.886 96.4047 102.095 97.2082C101.305 98.0116 100.227 98.4682 99.1002 98.4773C97.9731 98.4864 96.8885 98.0475 96.085 97.2569C95.2815 96.4664 94.825 95.389 94.8159 94.2619C94.8067 93.1348 95.2457 92.0502 96.0362 91.2467C96.8268 90.4432 97.9041 89.9867 99.0313 89.9776C100.158 89.9684 101.243 90.4074 102.046 91.198C102.85 91.9885 103.306 93.0658 103.316 94.193Z",
    stroke: "#285171",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirculo);
export default __webpack_public_path__ + "static/media/circulo.2d4fd29d3c9e52b274894282c63f97f3.svg";
export { ForwardRef as ReactComponent };